import { connect } from 'react-redux';
import config from 'config';
import { injectIntl } from 'react-intl';
import { branch, compose, lifecycle, renderComponent } from 'recompose';
import { getReschedulingOffer } from 'modules/reschedulingOffer/actions/getReschedulingOffer';
import { acceptReschedulingOffer } from 'modules/reschedulingOffer/actions/acceptReschedulingOffer';
import { declineReschedulingOffer } from 'modules/reschedulingOffer/actions/declineReschedulingOffer';

import Page404 from 'pages/Page404';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import ReschedulingOffer from './ReschedulingOffer';


const mapStateToProps = (state) => {
  const {
    message,
    status,
    acceptStatus,
    declineStatus,
    organizationName,
    isExpired,
    isDeclined,
    isAccepted,
  } = state.reschedulingOffer.reschedulingOffer;

  return {
    logoSrc: config.product_name === 'moh' ? '/assets/img/MoH_Logo.svg' : '/assets/img/logo-doctor-online.svg',
    logoAlt: config.product_name === 'moh' ? 'logo_MoH' : 'Online Doctor',
    isPending: [status, acceptStatus, declineStatus].includes(requestsStatuses.pending),
    isFailed: [status, acceptStatus, declineStatus].includes(requestsStatuses.failure),
    message,
    isExpired,
    isDeclined,
    isAccepted,
    organizationName,
  };
};

export default compose(
  connect(
    mapStateToProps,
    { getReschedulingOffer, acceptReschedulingOffer, declineReschedulingOffer },
  ),
  lifecycle({
    componentDidMount() {
    },
    componentWillMount() {
      const { getReschedulingOffer, offerId } = this.props;

      getReschedulingOffer(offerId);
    },
  }),

  branch(
    ({ isFailed, offerId }) => isFailed || !offerId,
    renderComponent(Page404),
  ),
)(injectIntl(ReschedulingOffer));
